import { Component } from "@angular/core";
import { RouterModule, RouterOutlet } from "@angular/router";
import { LoaderComponent } from "./shared/components/loader/loader.component";
import { TapToTopComponent } from "./shared/components/tap-to-top/tap-to-top.component";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { environment as env } from "../environments/environment";
import { GoogleTagManagerService } from "./shared/services/googletagmananer.service";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [
    RouterOutlet,
    RouterModule,
    LoaderComponent,
    TapToTopComponent,
    TranslateModule,
  ],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})

export class AppComponent {
  constructor(private translate: TranslateService, private gtmService: GoogleTagManagerService) {
    this.translate.addLangs(['ru', 'it']);
    const language = env?.defaultLanguage ?? 'it';
    this.translate.setDefaultLang(language);
    this.translate.use(language);
    this.gtmService.addGtm(env.gtmId)
  }
}
